import { FillItemContent, } from '@standardnotes/models';
import { ContentType } from '@standardnotes/domain-core';
export class HandleRootKeyChangedMessage {
    constructor(mutator, sync, _getVault, _decryptErroredPayloads) {
        this.mutator = mutator;
        this.sync = sync;
        this._getVault = _getVault;
        this._decryptErroredPayloads = _decryptErroredPayloads;
    }
    async execute(message) {
        const rootKeyContent = message.data.rootKey;
        await this.mutator.createItem(ContentType.TYPES.KeySystemRootKey, FillItemContent(rootKeyContent), true);
        const vault = this._getVault.execute({
            keySystemIdentifier: rootKeyContent.systemIdentifier,
        });
        if (!vault.isFailed()) {
            await this.mutator.changeItem(vault.getValue(), (mutator) => {
                mutator.rootKeyParams = rootKeyContent.keyParams;
            });
        }
        await this._decryptErroredPayloads.execute();
        void this.sync.sync({ sourceDescription: 'Not awaiting due to this event handler running from sync response' });
    }
}
